










import { CategoryItem } from '@/interfaces/category-item';
import MenuMixin from '@/mixins/menu-mixin';
import { mixins } from 'vue-class-component';
import { Component } from 'vue-property-decorator';
import { namespace, State } from 'vuex-class';
import Left from '../layout/left.vue';
const System = namespace('System');

@Component({
  components: { Left }
})
export default class Task extends mixins(MenuMixin) {
  @State MENU_INDENT: any;

  @System.State activeTabs: any;
  @System.Mutation setActiveTabs: any;

  menu: CategoryItem[] = [
    { title: '我的工作台', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] },
    { title: '预警监控台', icon: 'fa-cubes', type: 'folder', oprate: false, expand: true, children: [] }
  ];

  created() {
    this.initMenu();
  }

  initMenu() {
    if (this.ROLE_MENU.length === 0) {
      setTimeout(() => {
        this.initMenu();
      }, 100);
    } else {
      this.MENU('TODO') && this.menu[0].children.push({ title: '我的待办', key: '/task/todo', oprate: false, icon: 'fa-list-ol' });
      this.MENU('DONE') && this.menu[0].children.push({ title: '我的已办', key: '/task/done', oprate: false, icon: 'fa-list' });
      this.MENU('DASHBOARD') && this.menu[1].children.push({ title: '预警仪表盘', key: '/task/dashboard', oprate: false, icon: 'fa-bar-chart' });
      this.MENU('ALERT_MON') && this.menu[1].children.push({ title: '预警监督台', key: '/task/full', oprate: false, icon: 'fa-th' });
      this.MENU('DATAV_BOARD_ALERT') && this.menu[1].children.push({ title: '预警监控大屏', key: '/screen/alert', oprate: false, icon: 'fa-desktop' });
    }
  }

  update(key: string) {
    if (/\/screen/.test(key)) {
      let routeData = this.$router.resolve({ path: key });
      window.open(routeData.href, '_blank');
      return;
    }
    if (/\/task/.test(key)) {
      let index = this.activeTabs.findIndex((v: any) => v.path.startsWith(key));
      if (index > -1) {
        this.setActiveTabs(this.activeTabs[index]);
        this.$router.push(this.activeTabs[index].fullPath);
      } else {
        this.$router.push(key);
      }
    }
  }
}
